// extracted by mini-css-extract-plugin
module.exports = {"noCoordinatesBtn":"ReportsMap_noCoordinatesBtn__1uw2L"};